import React from 'react';

const SellType = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  return (
    <div className={'solid-dyna-input'}>
      <label htmlFor="sendData__sellType">بستر فروش</label>
      <select
        id={'sendData__sellType'}
        className=""
        onChange={e => setSendData({sellType: e.target.value})}
        required={true}
        value={sendData.sellType}
      >
        <option value="" hidden>
          بستر فروش
        </option>
        <option value="instagram">اینستاگرام</option>
        <option value="whatsapp">واتس اپ</option>
        <option value="website">وبسایت</option>
        <option value="inPlace">حضوری</option>
      </select>

    </div>
  );
};

export default SellType;
